<template>
    <b-modal id="attendance-create-modal" :hide-header="true" :hide-footer="true" :centered="true" ref="attendance-create-modal">
        <div class="modal-body">
            <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"
               @click="hide()">
                <span aria-hidden="true">&times;</span>
            </a>
            <div>
                <h4 v-if="model.type === 'edit'">Edit Attendance</h4>
                <h4 v-else>Add New Attendance</h4>
                <b-form @submit.prevent="submit" enctype="multipart/form-data">
                    <b-form-group label="Employee">
                      <b-select required v-model="model.employeeId">
                        <b-select-option v-for="employee in employees" v-bind:key="employee.employeeId" :value="employee.employeeId">{{employee.employeeFirstName}} {{employee.employeeLastName}}</b-select-option>
                      </b-select>
                    </b-form-group>
                    <b-form-group label="Attendance Date">
                        <b-input type="date" v-model="model.attendanceDate"/>
                    </b-form-group>
                    <b-form-group v-if="model.type === 'edit'" label="Status">
                      <b-select required v-model="model.status">
                        <b-select-option value="APPROVED">Approve</b-select-option>
                        <b-select-option value="DECLINED">Decline</b-select-option>
                        <b-select-option value="DELETED">Delete</b-select-option>
                      </b-select>
                    </b-form-group>
                    <base-button title="Submit" :loading="attendance.attendanceLoading"/>
                </b-form>
            </div>
        </div><!-- modal-body -->
    </b-modal>
</template>
<script>
    import { mapState } from "vuex"
    import BaseButton from "../button/BaseButton";
    export default {
        props:['show','row'],
        components:{BaseButton},
        name: 'ConfirmModal',
        data(){
            return{
                password: '',
                model:{
                  employeeId: '',
                  attendanceDate: '',
                  status: '',
                  attendanceReference: '',
                  qr: '',
                  employerId: ''
                },
            }
        },
        methods:{
            hide() {
                this.$refs['attendance-create-modal'].hide()
            },
            async submit(){
                this.model.employerId = localStorage.orgId
                this.model.qr = localStorage.orgId
                if (this.model.type === 'edit')
                  await this.$store.dispatch("attendance/editAttendance", this.model, {root: false});
                else {
                  this.model.attendanceEmployeeId = this.row.employeeId
                  await this.$store.dispatch("attendance/captureQR", this.model, {root: false});
                }
                this.hide();
                this.$store.dispatch('attendance/updateAttendanceByEmployer', {
                  readAll: 'NO',
                  employerId: localStorage.orgId
                })
                let self = this;
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                    self.model[key] = '';
                });

            },
            gradeCode(){
                return  localStorage._gradeCode
            },
            loadGrade(){
                this.$store.dispatch("grade/updateGradeSalaries", {
                    readAll:'NO',
                    employerGradeSalaryEmployerId: localStorage.orgId,
                    employerGradeSalaryGradeCode: localStorage._gradeCode
                }, {root: false}).then()
            },
            hideauth: function () {
                this.password = '';
                this.$refs['attendance-create-modal'].hide();
            },
            currentDate(){
                let date = new Date()
                date = this.$moment(date.toDateString()).format('YYYY-MM-DD')
                console.log(date)
                return date
            },
        },
        mounted() {
            //this.model = this.row readSkillCategory
          this.$store.dispatch('employee/readSkillCategory',{readAll:"YES"})
        },
        computed:{
            ...mapState(['grade','auth','employee','attendance']),
          employees(){
            return  this.employee.employees?this.employee.employees:[]
          },
        },
        watch: {
            show: function () {
                let self = this;
              // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                  self.model[key] = '';
                });
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.row).forEach(function(key,index) {
                    self.model[key] = self.row[key];
                });
                self.model.employeeId = self.row.attendanceEmployeeId
                self.model.attendanceReference = self.row.attendanceReference
                //self.model.qr = self.row.attendanceEmployeeId
                this.$refs['attendance-create-modal'].show()
            }
        },
    }
</script>
